export const CLEAR_SELECTED_SEAT = 'BUS/CLEAR_SELECTED_SEAT';

export default function clearSelectedSeat() {
  return {
    type: CLEAR_SELECTED_SEAT,
  };
}
